<template>
  <div id="app" :class="{'mobile':detectDeviceType}">
    <router-view></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {
  openDB,
  closeDB,
  deleteDBAll
} from '@/db/index'
export default {
  name: 'App',
  data(){
    return{}
  },
  computed:{
    ...mapState(['demoQuestionsList'])
  },
  components: {},
  created(){
    deleteDBAll('webTopchatDBv4')
    if(this.demoQuestionsList.length === 0){
      this.$store.dispatch('getDemoQuestionsList')
    }
    this.$store.dispatch('setIndexedDB')
  },
  watch:{
    $route(to,form){
      if(to.meta && to.meta.deviceType == 'mobile'){
        this.deviceType = false
      }
    }
  },
  mounted(){
    if(this.detectDeviceType){
      window.onload=function () {
        document.addEventListener('touchstart',function (event) {
          if(event.touches.length>1){
            event.preventDefault();
          }
        });
        var lastTouchEnd=0;
        document.addEventListener('touchend',function (event) {
          var now=(new Date()).getTime();
          if(now-lastTouchEnd<=300){
            event.preventDefault();
          }
          lastTouchEnd=now;
        },false);
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault();
        });
      }
    }
  },
  methods:{},
  destroyed(){
    closeDB(this.db)
  }
}
</script>

<style lang="less">
#app{
  color: var(--fontColor);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.mobile{
  height:100%;
}

</style>
